import type * as React from 'react';

import { OverlayFocusContainedContext, ScreenTypeProvider } from '@gitbook/spine-react';

import { UsingKeyboardContextProvider } from './Events';
import { Palette, useIsPaletteOpened } from './Palette';
import { ThemeConfigurationProvider } from './theme';

/**
 * Provider for all the contexts.
 */
export function UIKitProvider(props: { children: React.ReactNode }): React.ReactElement {
    const { children, ...rest } = props;
    const isPaletteOpened = useIsPaletteOpened();
    return (
        <ThemeConfigurationProvider>
            <ScreenTypeProvider>
                <UsingKeyboardContextProvider>
                    <OverlayFocusContainedContext.Provider value={!isPaletteOpened}>
                        <Palette {...rest} />
                        {children}
                    </OverlayFocusContainedContext.Provider>
                </UsingKeyboardContextProvider>
            </ScreenTypeProvider>
        </ThemeConfigurationProvider>
    );
}
